import * as React from 'react';
export const stepContext = /*#__PURE__*/React.createContext({
  step: 0
});
export const useStepContext = () => React.useContext(stepContext);
//# sourceMappingURL=es/FormUI/Step/stepContext.js.map